import { Component, OnInit, Inject, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { ManikEntityFE, CookieManager } from 'src/app/manik-library/ManikEntityFE';
import { ClickToCallModel } from 'src/app/models/web-card-model';
import { ManikEntityService } from 'src/app/manik-library/ManikEntityService';
declare const $: any;
declare const grecaptcha: any;
@Component({
  selector: 'click-to-call',
  templateUrl: './click-to-call.component.html',
  styleUrls: ['./click-to-call.component.scss']
})
export class ClickToCallComponent extends ManikEntityFE implements OnInit, OnChanges {
  ClickToCallForm: FormGroup;
  C2CModel: ClickToCallModel = new ClickToCallModel();
  WebSiteMetaData = JSON.parse(sessionStorage.getItem("SiteMetaData"));
  ClicktoCallRecaptcha: any;
  CaptchaInvalid: boolean = false;
  CaptchaMessage: string = '';
  UserLoggedIn: boolean;
  @Input() VisitorData: any;
  @Output() VisitorLoggedIn = new EventEmitter();
  constructor(private formBuilder: FormBuilder, public _manikEntityService: ManikEntityService, @Inject(DOCUMENT) public document: any) {
    super(document);
    this.ClickToCallForm = this.formBuilder.group({
      EnquirerName: ['', Validators.required],
      EnquirerEmail: ['', [Validators.required, Validators.email]],
      EnquirerPhone: ['', Validators.required],
      OKToContactBack: ['',Validators.required]
    });
  }

  ngOnInit() {
    this.WebSiteMetaData = JSON.parse(sessionStorage.getItem("SiteMetaData"));
    this.C2CModel.BusinessName = this.WebSiteMetaData.Title;
    this.CheckUserLoggedIn();
  }
  CaptchaInitialized: boolean = false;
  ngOnChanges() {
    this.CheckUserLoggedIn();
  }

  CheckUserLoggedIn() {

    if (CookieManager.getCookie('VisitorData')) {
      let x = JSON.parse(CookieManager.getCookie('VisitorData'));
      if (x) {
        if (x.VisitorName) {
          this.UserLoggedIn = true;
          this.ClickToCallForm.controls['EnquirerName'].setValue(x.VisitorName);
          this.ClickToCallForm.controls['EnquirerEmail'].setValue(x.EmailID);
          this.ClickToCallForm.controls['EnquirerPhone'].setValue(x.MobileNumber);
          setTimeout(() => {
            if (!this.CaptchaInitialized) {
              this.InitCaptcha(this.ClicktoCallRecaptcha, 'c2cForm', grecaptcha);
              this.CaptchaInitialized = true;
            }
          }, 1000)
        }
        else {
          this.UserLoggedIn = false;
        }
      }
      else {
        this.UserLoggedIn = false;
      }
    }
  }

  populateControls(): void {
  }
  refreshDataGrid(param: any): void {
  }



  Emit() {
    this.VisitorLoggedIn.emit('Y');
  }
  SubmitCallMeBack(): void {
    if (this.ClickToCallForm.invalid) {
        return;
    }
    this.CaptchaInvalid = false;
    this.C2CModel.IsSubmitted = true;
    this.CaptchaMessage = '';
    let x = grecaptcha.getResponse(this.ClicktoCallRecaptcha);
    this._manikEntityService.manikEntityConnect2('WebSite/captcha/v2?sToken=' + x, null, null)
      .subscribe(data => {
        if (data.success) {
          this.SubmitForm();
        }
        else {
          this.CaptchaInvalid = true;
          this.C2CModel.IsSubmitted = false;
          if (data['error-codes'].find(item => {
            return item == 'missing-input-response'
          })) {
            this.CaptchaMessage = 'Please click on the checkbox';
          }
          if (data['error-codes'].find(item => {
            return item == 'timeout-or-duplicate'
          })) {
            this.CaptchaMessage = 'Please click on the checkbox again';
          }

        }
      });
  }

  SubmitForm() {
    console.log(this.ClickToCallForm)
    if (this.ClickToCallForm.invalid) {
      this.C2CModel.IsSubmitted=false;
      return;
    }
    let body: any = this.ClickToCallForm.value;
    body["BusinessHandle"] = JSON.parse(sessionStorage.getItem("SiteMetaData")).BizHandle;
    body["BusinessID"] = JSON.parse(sessionStorage.getItem("SiteMetaData")).BID;
    body["ChannelID"] = "W";
    body["OKToContactBack"] = body.OKToContactBack ? "Y" : "N";
    let SubmittedData = JSON.stringify({ "items": [body] });
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", SubmittedData,
      this.prepareManageHeaders2("A", "BUSINESSECOSYSTEM.CALLMEBACK", "BIZ"))
      .subscribe(data => {
        let id = data.ManikJSon[0].JSon0[0].NewEntity;

        $("#lblRMessage").text("Your request has been submitted!");
        $("#lblRMessage").show();
       
        setTimeout(() => {          
          $("#lblRMessage").hide();
          $('#callModel').modal('hide');
          this.ClickToCallForm.reset()
          this.cancel();
          this.C2CModel.IsSubmitted = false;
        }, 4000);
       


      });
  }

  get C2CForm() {
    return this.ClickToCallForm.controls;
  }

  cancel(){    
    this.ClickToCallForm.reset(); 
    this.ClickToCallForm.get('EnquirerName').clearValidators();
    // this.ClickToCallForm.get('EnquirerEmail').clearValidators();
    // this.ClickToCallForm.get('EnquirerPhone').clearValidators();
    // this.ClickToCallForm.get('OKToContactBack').clearValidators();
  
  }
}
